import { isEmpty, keys, map } from 'lodash';
import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TableFilters from '../Custom/TableFilters';

const TableComponent = ({ data }) => {
  const [columns, setColumns] = useState([]);
  const onFilterApply = (name, filterId) => {
    let obj = [];
    obj = Array.from(
      document.querySelectorAll(`input[name=${name}]:checked`)
    ).map((checkbox) => checkbox.value.toLowerCase());
    return obj.length > 0
      ? obj.includes(filterId.toString().toLowerCase())
      : true;
  };
  useEffect(() => {
    const tempData = map(keys(data[0]), (item) => ({
      Header: <div className="bold-black">{item}</div>,
      accessor: `${isEmpty(item) ? 'NA' : item}`,
      className: 'text-center',
      filterable: true,
      filterMethod: (filter, row) => onFilterApply(item, row[filter.id]),
      // eslint-disable-next-line react/display-name
      Filter: ({ onChange }) => (
        <TableFilters
          position="-20px"
          onChange={onChange}
          filterObj={[...new Set(data.map((x) => x[item]))]}
          valueObj={[...new Set(data.map((x) => x[item]))]}
          name={item}
          id={`fltr${item}`}
          listid={`lstfltr${item}`}
        />
      ),
    }));
    setColumns(tempData);
  }, [data]);

  if (columns.length === 0) {
    return <span>Loading...</span>;
  }
  return (
    <div style={{ backgroundColor: '#fff' }}>
      <ReactTable
        columns={columns}
        data={data}
        showPagination={false}
        className="-striped -highlight"
        style={{
          height: 'calc(100vh - 232px)',
        }}
        pageSize={data.length}
        resizable={false}
        sortable={true}
        filterable={true}
      />
    </div>
  );
};

// TableComponent.propTypes = {
//     type: PropTypes.string.isRequired,
//     id: PropTypes.string.isRequired,
// };

export default TableComponent;
